import { render } from "./verify-account.vue?vue&type=template&id=b48bc064&scoped=true"
import script from "./verify-account.vue?vue&type=script&lang=js"
export * from "./verify-account.vue?vue&type=script&lang=js"

import "./verify-account.vue?vue&type=style&index=0&id=b48bc064&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48bc064"]])

export default __exports__